import { useQuery, type UseQueryResult } from 'react-query';
import {
  StockClassService,
  type Wealthlane_CapTable_Dtos_StockClass_CurrentIssuerStockClassListItemDto,
} from '@wealthlane/api-services/wealthlane-captable-service';

const useGetCurrentIssuerStockClasses = (
  handleRequest: <T>(request: Promise<T>) => Promise<T | undefined>,
  asOfDate?: string,
  options?: { enabledWithoutAsOfDate?: boolean }
): UseQueryResult<
  Wealthlane_CapTable_Dtos_StockClass_CurrentIssuerStockClassListItemDto[] | undefined,
  unknown
> => {
  const dateOnly = asOfDate?.split('T')[0];
  const loadWithoutAsOfDate = options?.enabledWithoutAsOfDate === true;

  return useQuery(
    ['getCurrentIssuerStockClasses', loadWithoutAsOfDate ? 'all' : dateOnly],
    async () => {
      return await handleRequest(
        StockClassService.getApiCapTableApiAppStockClassCurrentIssuerStockClassList(
          loadWithoutAsOfDate ? undefined : asOfDate
        )
      );
    },
    {
      enabled: loadWithoutAsOfDate || !!asOfDate,
      staleTime: 5 * 60 * 1000,
    }
  );
};

export default useGetCurrentIssuerStockClasses;
